// extracted by mini-css-extract-plugin
export default {"organizationCardText":"organizationCard_organizationCardText__5EVKv","organizationCardName":"organizationCard_organizationCardName__JCoz5"};